import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AuthCallback from '@/views/AuthCallback.vue' // 回调处理页面

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/auth/callback',
      name: 'AuthCallback',
      component: AuthCallback,
      meta: {
        requiresAuth: false // 回调页面不需要提前授权
      }
    },
  ],
})

export default router
